import { render, staticRenderFns } from "./PersonAddressView.vue?vue&type=template&id=34515f95&scoped=true&"
import script from "./PersonAddressView.vue?vue&type=script&lang=js&"
export * from "./PersonAddressView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34515f95",
  null
  
)

export default component.exports